<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Editar amparo</h5>
    <div mat-dialog-content>
        <!--begin::Form-->
        <form class="form" [formGroup]="editProtectionForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
            <br-alert *ngIf="showAlert"></br-alert>
            <p><strong>ID: </strong>{{protectionData.id}}</p>
            <p><strong>Fecha de creación: </strong>{{protectionData.createdAt | date: 'MMMM d, y'}}</p>
            <mat-form-field class="w-100">
            <mat-label>Amparo</mat-label>
            <input matInput type="text"
                formControlName="protection" autocomplete="off" />
            <mat-error *ngIf="isControlHasError('protection', 'required')">
                <strong>Campo requerido</strong>
            </mat-error>
            </mat-form-field>
        </div>
        </form>
        <!--end::Form-->
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick(false)">Cerrar</button>
        <button mat-button cdkFocusInitial (click)="submit(editProtectionForm)">Guardar</button>
    </div>
</div>